import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {insightsPageInitialState} from './insightsPage.consts';
import {
  AvailableDimension,
  AvailableMetricWithTotal,
  InsightsPageState,
  MeasuredPeriod,
} from './insightsPage.types';
import {Dashboard, DashboardWidget} from 'common/src/modules/dashboards/dashboards.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

const insightsPageSlice = createSlice({
  name: BreadcrumbName.CampaignInsights,
  initialState: insightsPageInitialState,
  reducers: {
    resetInsightsPage: () => insightsPageInitialState,
    updateInsightsPage: (_, action: PayloadAction<InsightsPageState>) => {
      return action.payload;
    },
    updateMeasuredPeriod: (state, action: PayloadAction<Partial<MeasuredPeriod>>) => {
      state.measuredPeriod = {...state.measuredPeriod, ...action.payload};
    },
    updateAvailableMetricsWithTotals: (
      state,
      action: PayloadAction<AvailableMetricWithTotal[]>,
    ) => {
      state.availableMetricsWithTotals = action.payload;
    },
    updateAvailableDimensions: (state, action: PayloadAction<AvailableDimension[]>) => {
      state.availableDimensions = action.payload;
    },
    updateDashboards: (state, action: PayloadAction<Dashboard[]>) => {
      state.dashboards = action.payload;
    },
    updateWidgets: (state, action: PayloadAction<DashboardWidget[]>) => {
      state.widgets = action.payload;
    },
  },
});

const {
  resetInsightsPage,
  updateInsightsPage,
  updateMeasuredPeriod,
  updateAvailableMetricsWithTotals,
  updateAvailableDimensions,
  updateDashboards,
  updateWidgets,
} = insightsPageSlice.actions;

export {
  resetInsightsPage,
  updateInsightsPage,
  updateMeasuredPeriod,
  updateAvailableMetricsWithTotals,
  updateAvailableDimensions,
  updateDashboards,
  updateWidgets,
};

export default insightsPageSlice.reducer;
